// Defines the shape of data expected for file-related operations
type FileData = {
    url: string;
    file: File | string;
    local_id: number;
};

// Send file data to the API
export const sendFile = async (data: FileData): Promise<any> => {
    // Get the authentication token from local storage and  Set the headers for the request
    const token = localStorage.getItem('token');
    const headers = { Authorization: `Bearer ${token}` };

    // Create a FormData object for handling file uploads
    const formData = new FormData();
    formData.append('file', data.file);
    formData.append('local_id', data.local_id.toString());

    try {
        // Make a POST request to the API with FormData body
        const response = await fetch(data.url, {
            method: 'POST',
            headers,
            body: formData,
        });

        if (!response.ok) {
            // Handle JSON error response from server
            const errorData = await response.json();
            const errorMessage = errorData.message || 'Unknown error occurred';

            // Get validation errors if they exist
            const validationErrors = errorData?.errors?.file;

            return validationErrors?.[0] || errorMessage;
        }

        const payload = await response.json();

        return payload?.data;
    } catch (error) {
        console.error('Fetch error:', error);
        throw error;
    }
};
